module.exports = __webpack_public_path__ + "europa-50-microprint.jpg?2b2bd87fb43c767da9d39f246b2b59cd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-50-microprint.jpg
// module id = 362
// module chunks = 0